
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16.5","cy":"16.5","r":"15.4","stroke":"#ABAFB5","stroke-width":"1.2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.732 10.2a.799.799 0 00-.334.65v11.3a.8.8 0 00.8.8h12.284l-8.8-8.8H8.448v-3h.234l-.95-.95zm9.607 3.95h7.21v-3h-10.21l-1.1-1.1h11.56a.8.8 0 01.8.8v11.3a.803.803 0 01-.033.227l-8.227-8.227z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M6.3 5.79l21.292 21.292","stroke":"#ABAFB5","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    